import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { HttpClientError, IQuerySettings, QueryKeys, getQuerySettings } from '@dw/models/shared';
import { IUpdateSelfRequest, IUser } from '@dw/models/user';
import { useHttpClient, useSnackbar } from '@dw/hooks';

const BASE_URL = '/v1/users';

export const useGetSelf = (settings?: IQuerySettings<IUser>) => {
    const { GET } = useHttpClient();

    const querySettings = getQuerySettings(settings);
    return useQuery<IUser, HttpClientError>({
      queryKey: [QueryKeys.Self],
      queryFn: () => {
        return GET<IUser>(`${BASE_URL}/self`, undefined, {
          autoShowErrorMessages: querySettings.autoShowErrorMessages,
          autoLogOutOnAuthError: querySettings.autoLogOutOnAuthError
        });
      },
      ...querySettings
    });
}

export const useUpdateSelfMutation = (settings?: IQuerySettings<IUser, IUpdateSelfRequest>) => {
    const { PUT } = useHttpClient();
    const queryClient = useQueryClient();
    const { showSnackbar } = useSnackbar();

    const updateSelf = async (request: IUpdateSelfRequest) => {
        return PUT<IUser>(`${BASE_URL}/self`, request);
    }

    const querySettings = getQuerySettings(settings)
    return useMutation<IUser, HttpClientError, IUpdateSelfRequest>({
      mutationFn: updateSelf,
      onSuccess: (response, input) => {
        showSnackbar('Successfully updated account details.')
        queryClient.setQueryData([QueryKeys.Self], response);
        if (querySettings.onSuccess) {
          querySettings.onSuccess(response, input)
        }
      },
      onError: querySettings.onError
    })
}